import { EFinancingProgram } from '@if/core/types'
import { useQuery } from '@tanstack/react-query'
import { getApiClient } from './api-client'

const FINANCINGCONFIGS = 'financing-configs'

const keysFactory = {
  allFinancingConfigs: () => [{ scope: FINANCINGCONFIGS }] as const,
}

export interface FinancingConfigDto {
  financingProgramId: EFinancingProgram
  maximumLoanAmount: number
  minimumLoanAmount: number
  minLoanTerm: number
  maxLoanTerm: number
}

const getFinancingConfigs = async () => {
  const apiClient = getApiClient()
  const response = await apiClient.get<FinancingConfigDto[]>('/FinancingConfigs')
  return response.data
}

export function useFinancingConfigs(): [FinancingConfigDto[], boolean] {
  const { isFetching, data } = useQuery({
    queryKey: keysFactory.allFinancingConfigs(),
    queryFn: getFinancingConfigs,
    initialData: [],
  })

  return [data, isFetching]
}
